const TONES = ["food", "travel", "shopping", "bills", "entertainment", "medical"];

const KNOWN = {
  food: "food",
  travel: "travel",
  commute: "travel",
  transport: "travel",
  shopping: "shopping",
  bills: "bills",
  entertainment: "entertainment",
  medical: "medical",
  health: "medical",
  misc: "misc",
  other: "misc",
};

export function tagTone(value) {
  const key = String(value ?? "").trim().toLowerCase();
  if (!key) return "misc";
  if (KNOWN[key]) return KNOWN[key];

  let hash = 0;
  for (let i = 0; i < key.length; i += 1) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  return TONES[hash % TONES.length];
}
